export enum GroupLicenseManualActivationEnum {
  MANUALLY_ACTIVATED = 'MANUALLY_ACTIVATED',
  MANUALLY_DEACTIVATED = 'MANUALLY_DEACTIVATED'
}
